import * as actionTypes from "../../../constants/ActionTypes/AdminPortal/InvoicePosting";

const initialState = {
    data: {},
    loading: false,
    success: false,
    error: null
}

const TESIInvoice_RETRY = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RETRY_INVOICE_INIT:
            return {
                ...state,
                loading: true,
                success: false
            }
        
        case actionTypes.RETRY_INVOICE_SUCCESS:
            return {
                ...state,
                data: action.data,
                loading: false,
                error: null,
                success: true
            }
        
        case actionTypes.RETRY_INVOICE_ERROR:
            return {
                ...state,
                loading: false,
                error: action.message,
                success: false,
                data: {}
            }
        case actionTypes.RETRY_INVOICE_RESET:
            return {
                data: {},
                loading: false,
                success: false,
                error: null
            }
        default:
            return {...state}
    }
}

export default TESIInvoice_RETRY